export default __webpack_public_path__ + "static/media/img-parent-bg-models.7c7bfef2.png";